import { subtractFromDate } from 'utils/dates';

export const jobs_page_query = {
  filter: null,
  start_date: null,
  finish_date: null,
  job_state_id: 1,
  include_archived: false,
  max_rows: 100,
  created_by: null,
};

export const jobs_post_data = {
  filter: '',
  start_date: subtractFromDate(new Date(), { decrement: 0 }),
  finish_date: subtractFromDate(new Date(), { decrement: 1 }),
  job_state_id: 1,
  include_archived: false,
  max_rows: 100,
  created_by: null,
};
